import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import InterviewView from "@/views/InterviewView.vue";
import LpSearchView from "@/views/LpSearchView.vue";
import LpView from "@/views/LpView.vue";
import KLpView from "@/views/KLpView.vue";
import ReportView from "@/views/ReportView.vue";
import ExpectationView from "@/views/ExpectationView.vue";
import CategoryView from "@/views/CategoryView.vue";
import KeywordView from "@/views/KeywordView.vue";
import FreewordView from "@/views/FreewordView.vue";
import HistoryView from "@/views/HistoryView.vue";
import TermsView from "@/views/TermsView.vue";
import PolicyView from "@/views/PolicyView.vue";
import CompanyView from "@/views/CompanyView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/qa/question/:id",
    name: "interview",
    component: InterviewView,
  },
  {
    path: "/qa/start/:id",
    name: "expectation",
    component: ExpectationView,
  },
  {
    path: "/search/:id",
    name: "lp",
    component: LpSearchView,
  },
  {
    path: "/lsearch/:id",
    name: "clp",
    component: LpView,
  },
  {
    path: "/ksearch/:id",
    name: "klp",
    component: KLpView,
  },
  {
    path: "/qa/result/:id",
    name: "report",
    component: ReportView,
  },
  {
    path: "/category",
    name: "category",
    component: CategoryView,
  },
  {
    path: "/keyword",
    name: "keyword",
    component: KeywordView,
  },
  {
    path: "/qa/freeword",
    name: "freeword",
    component: FreewordView,
  },
  {
    path: "/qa/history/:id",
    name: "history",
    component: HistoryView,
  },
  {
    path: "/terms",
    name: "terms",
    component: TermsView,
  },
  {
    path: "/policy",
    name: "policy",
    component: PolicyView,
  },
  {
    path: "/company",
    name: "company",
    component: CompanyView,
  },
];

const router = createRouter({
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
    };
  },
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
